var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-badge',{attrs:{"spec":_vm.spec}},[_c('v-icon',{style:(_vm.genericStyles()),attrs:{"size":_vm.size,"color":_vm.color}},[_vm._v(_vm._s(_vm.value))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }